import { FullProgramResponse, SimpleProgramResponse } from '@front-app/api-generated/learning-management-api';
import {
	AnyLearningItem,
	LearningModule,
	LearningPart,
	LearningProgram,
	LearningStep,
} from '../Model';

export const isFullProgram = (
	item: SimpleProgramResponse | FullProgramResponse,
): item is FullProgramResponse => Array.isArray((item as FullProgramResponse).modules);

export const isProgram = (item: AnyLearningItem): item is LearningProgram => Array.isArray((item as LearningProgram).modules);

export const isModule = (item: AnyLearningItem): item is LearningModule => Array.isArray((item as LearningModule).parts);

export const isPart = (item: AnyLearningItem): item is LearningPart => Array.isArray((item as LearningPart).steps);

export const isStep = (item: AnyLearningItem): item is LearningStep => Object.hasOwnProperty.call(item, 'content');
